import { InternalChargeCardAccount, Query } from '@varo/graphql-schema-types';
import { useEffect } from 'react';
import QueryMyAccountsBelieveCardAccount from 'services/graphql/queries/MyAccountsBelieveCardAccount.query';
import { useQuery } from 'urql';

interface UseBelieveAccountResult {
  account: InternalChargeCardAccount | null | undefined;
  fetching: boolean;
  error: Error | undefined;
}

const useBelieveAccount = (): UseBelieveAccountResult => {
  const [{ data, fetching, error }, refetch] = useQuery<Query>({
    query: QueryMyAccountsBelieveCardAccount,
    requestPolicy: 'cache-and-network',
    pause: true,
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  const account = data?.myAccounts?.chargeCard;

  return {
    account,
    fetching,
    error,
  };
};

export default useBelieveAccount;
